<template>
  <div class="va-row">
    <div class="flex md12 xs12">
      <vuestic-data-table
        class="text-center"
        :apiMode="true"
        :apiUrl="apiUrl"
        :httpOptions="httpOptions"
        :defaultPerPage="defaultTablePerPage"
        :tableFields="tableFields"
        :actions="true"
        :actionsType="'reporting'"
        :additionalActions="true"
        :filterInputShown="false"
        v-on:pagination-data-updated="setPaginationData"
      >
        <template slot="additionalTableControl">
          <button
            v-if="schedule"
            class="btn rounded btn-micro btn-with-icon-micro btn-warning mx-2"
            @click="$store.dispatch('togglePopup', true)"
          >
            <div class="btn-with-icon-content">
              <i class="fa fa-calendar"></i>
              Schedule
            </div>
          </button>
          <button
            class="btn rounded btn-micro btn-with-icon-micro btn-primary"
            :class="{ loading: downloadingFile }"
            :disabled="!canDownload"
            @click="downloadReport"
          >
            <div class="btn-with-icon-content">
              <i class="fa fa-download"></i>
              Download
            </div>
          </button>
        </template>
      </vuestic-data-table>
    </div>
    <app-popup v-if="schedule">
      <template slot="popup-content">
        <form @submit.prevent="formHandler" class="w-100">
          <h4 class="text-primary text-center">Schedule Report</h4>
          <div class="va-row w-100 align--center justify--center">
            <div class="flex md5 xs12 required">
              <label for="name">Report name</label>
            </div>
            <div class="flex md7 xs12">
              <div
                class="form-group"
                :class="error.reportName ? 'has-error' : ''"
              >
                <div class="input-group">
                  <input
                    type="text"
                    id="name"
                    v-model="model.reportName"
                    placeholder="Report name"
                    required
                  />
                  <i class="bar"></i>
                  <span class="small text-danger">{{ error.reportName }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="va-row w-100 align--center justify--center">
            <div class="flex md5 xs12 required">
              <label for="name">Send report automatically</label>
            </div>
            <div class="flex md7 xs12" :class="error.cron ? 'has-error' : ''">
              <vuestic-simple-select
                :options="cronOptions"
                v-model="model.cron"
                :clearable="false"
                :pholder="'Select period'"
                required
              />
              <span class="small text-danger">{{ error.cron }}</span>
            </div>
          </div>
          <div class="va-row w-100 align--center justify--center">
            <div class="flex md5 xs12 required">
              <label for="name">Share with</label>
            </div>
            <div class="flex md7 xs12">
              <div class="form-group" :class="error.emails ? 'has-error' : ''">
                <div class="input-group">
                  <input
                    type="text"
                    id="emails"
                    v-model="model.emails"
                    placeholder="emails separated with a comma ','"
                    required
                  />
                  <i class="bar"></i>
                  <span class="small text-danger">{{ error.emails }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="va-row mt-3 w-100 justify--center">
            <half-circle-spinner
              slot="loading"
              :animation-duration="1500"
              :size="50"
              color="#94c120"
              v-show="formLoading"
              class="mt-2"
            />
            <div class="flex md6" v-if="!formLoading">
              <button type="submit" class="btn btn-primary btn-block btn-micro">
                Save
              </button>
            </div>
            <div class="flex md6" v-if="!formLoading">
              <button
                type="button"
                class="btn btn-danger btn-block btn-micro"
                @click="$store.dispatch('togglePopup', false)"
              >
                Cancel
              </button>
            </div>
          </div>
        </form>
      </template>
    </app-popup>
    <app-filterbar
      v-on:apply-filters="applyFilters"
      v-on:reset-filters="resetFilters"
    >
      <template slot="filterbar-content">
        <div class="filterbar-input">
          <label for="call_date" class="filter-selector">
            <input type="checkbox" id="call_date" v-model="filterByDateRange" />
            Date Range
          </label>
          <vuestic-date-picker
            v-model="dateRange.from"
            placeholder="From"
            :config="{ maxDate: dateRange.to }"
          />
          <vuestic-date-picker
            v-model="dateRange.to"
            placeholder="To"
            :config="{ minDate: dateRange.from }"
          />
        </div>

        <div class="filterbar-input">
          <p class="filter-selector">
            <!-- <input
              type="checkbox"
              id="extension_number"
              v-model="filterByExtensions"
            /> -->
            Extension number
          </p>
          <vuestic-multi-select
            v-model="filteredExtensions"
            :options="extensionNumbers"
            :optionKey="'ext'"
            pholder="Choose Extension No."
          />
        </div>
        <div class="filterbar-input">
          <label for="direction" class="filter-selector">
            <input type="checkbox" id="direction" v-model="filterByDirection" />
            Direction
          </label>
          <label
            v-for="directionOption in directionOptions"
            :for="directionOption.direction"
            v-bind:key="directionOption.direction"
            class="sub-filter"
          >
            <input
              type="checkbox"
              :id="directionOption.direction"
              v-model="directionOption.search"
            />
            {{ directionOption.title }}
          </label>
        </div>
        <div class="filterbar-input">
          <label for="call_status" class="filter-selector">
            <input
              type="checkbox"
              id="call_status"
              v-model="filterByCallStatus"
            />
            Status
          </label>
          <label
            v-for="callStatusOption in callStatusOptions"
            :for="callStatusOption.status"
            v-bind:key="callStatusOption.status"
            class="sub-filter"
          >
            <input
              type="checkbox"
              :id="callStatusOption.status"
              v-model="callStatusOption.search"
            />
            {{ callStatusOption.title }}
          </label>
        </div>
        <div class="filterbar-input">
          <label for="duration" class="filter-selector">
            <input
              type="checkbox"
              id="duration"
              v-model="callDuration.search"
            />
            Duration
            <span
              class="text-info small ml-auto"
              v-if="callDuration.value !== 0"
              >{{ callDuration.value }} Sec</span
            >
          </label>
          <slider
            v-bind="sliderOptions"
            ref="slider"
            v-model="callDuration.value"
          />
        </div>
      </template>
    </app-filterbar>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters, mapActions } from 'vuex'

import AppFilterbar from '@/components/admin/app-filterbar/AppFilterbar'

import CallStatus from './components/call-status'
import CallDirection from './components/call-direction'
Vue.component('call-status', CallStatus)
Vue.component('call-direction', CallDirection)

import Slider from 'vue-slider-component'
import HalfCircleSpinner from 'epic-spinners/src/components/lib/HalfCircleSpinner'

export default {
  components: {
    AppFilterbar,
    Slider,
    HalfCircleSpinner
  },
  data() {
    return {
      sliderOptions: {
        dotSize: 20,
        height: 10,
        tooltip: 'none',
        tooltipPlacement: 'bottom',
        min: 0,
        max: 300,
        direction: 'ltr',
        realTime: true,
        sliderStyle: {
          'background-color': this.$store.getters.palette.info,
          'box-shadow': 'none'
        },
        processStyle: {
          'background-color': this.$store.getters.palette.info,
          'border-radius': '7px'
        },
        tooltipStyle: {
          'background-color': this.$store.getters.palette.info,
          'border-color': this.$store.getters.palette.info
        },
        railStyle: {
          'background-color': '#FFF',
          'border-color': '#FFF',
          'border-radius': '7px',
          cursor: 'pointer'
        },
        dotStyle: {
          'background-color': this.$store.getters.palette.info,
          'border-color': this.$store.getters.palette.info,
          background: this.$store.getters.palette.info,
          width: '100%',
          height: '100%',
          'border-radius': '50%'
        }
      },
      schedule: false,
      canDownload: false,
      formLoading: false,
      model: {},
      error: {},
      cronOptions: ['daily', 'weekly', 'monthly', 'yearly'],
      httpOptions: {
        headers: { Authorization: 'Bearer ' + localStorage.getItem('cTok') }
      },
      filterByExtensions: false,
      filteredExtensions: [],
      filterByDirection: false,
      filterByCallStatus: false,
      filterByDateRange: false,
      dateRange: {
        from: '',
        to: ''
      },
      callDuration: {
        search: false,
        value: 0
      },
      directionOptions: [
        {
          title: 'Inbound',
          direction: 'income',
          search: false
        },
        {
          title: 'Outbound',
          direction: 'out_going',
          search: false
        },
        {
          title: 'Local',
          direction: 'local',
          search: false
        }
      ],
      callStatusOptions: [
        {
          title: 'Answered',
          status: 'ANSWERED',
          search: false
        },
        {
          title: 'Failed',
          status: 'FAILED',
          search: false
        },
        {
          title: 'No Answer',
          status: 'NO ANSWER',
          search: false
        },
        {
          title: 'Busy',
          status: 'BUSY',
          search: false
        }
      ],
      filter: {
        directions: '',
        callStatuses: '',
        extensions: '',
        callDuration: '',
        dateRange: {
          from: '',
          to: ''
        }
      },
      downloadingFile: false,
      tableFields: [
        {
          name: '__component:call-direction',
          title: 'Call Direction'
        },
        {
          name: '__component:call-status',
          title: 'Call Status',
          dataClass: 'with-icon'
        },
        {
          name: 'call_date_time',
          title: 'Call Date'
        },
        {
          name: 'duration',
          title: 'Call Duration'
        },
        {
          name: 'source',
          title: 'Source'
        },
        {
          name: 'destination',
          title: 'Destination'
        }
      ],
      defaultTablePerPage: 10,
      page: 1,
      per_page: 10
    }
  },
  computed: {
    ...mapGetters(['currentAccount', 'allExtensions']),
    apiUrl() {
      return `${process.env.VUE_APP_WEBSITE_URL}sip/provisioningwa/api/v1/call-log-report?tenant_id=${this.currentAccount.id}&extensions=${this.filter.extensions}&call_directions=${this.filter.directions}&call_statuses=${this.filter.callStatuses}&call_duration=${this.filter.callDuration}&from_date=${this.filter.dateRange.from}&to_date=${this.filter.dateRange.to}`
    },
    extensionNumbers() {
      return this.allExtensions
    }
  },
  methods: {
    ...mapActions([
      'fetchAllExtensions',
      'scheduleReport',
      'exportReport',
      'scheduleReport'
    ]),
    setPaginationData(val) {
      this.page = val.page
      this.per_page = val.per_page
    },
    async openFilterbar() {
      if (this.allExtensions.length === 0) {
        await this.$store.dispatch('fetchAllExtensions')
      }
      this.extensionNumbers = this.allExtensions
      this.$store.dispatch('toggleFilterbar', true)
    },
    applyFilters() {
      if (this.filterByDirection) {
        this.filter.directions = this.directionOptions
          .filter(option => option.search)
          .map(option => option.direction)
          .join(',')
      } else {
        this.filter.directions = ''
      }
      if (this.filterByCallStatus) {
        this.filter.callStatuses = this.callStatusOptions
          .filter(option => option.search)
          .map(option => option.status)
          .join(',')
      } else {
        this.filter.callStatuses = ''
      }
      if (this.filteredExtensions.length > 0) {
        this.filter.extensions = this.filteredExtensions
          .map(ex => ex.ext)
          .join(',')
      } else {
        this.filter.extensions = ''
      }
      if (this.callDuration.search) {
        this.filter.callDuration = this.callDuration.value
      } else {
        this.filter.callDuration = ''
      }
      if (this.filterByDateRange) {
        if (this.dateRange.from != '' && this.dateRange.to != '') {
          this.filter.dateRange.from = this.dateRange.from
          this.filter.dateRange.to = this.dateRange.to
        }
      } else {
        this.filter.dateRange.from = ''
        this.filter.dateRange.to = ''
      }
      if (
        this.filter.directions ||
        this.filter.callStatuses ||
        this.filter.extensions ||
        this.filter.callDuration ||
        (this.filter.dateRange.from && this.filter.dateRange.to)
      ) {
        this.canDownload = true
      } else {
        this.canDownload = false
      }
    },
    resetFilters() {
      this.canDownload = false
      this.filterByExtensions = false
      this.filteredExtensions = []
      this.filterByDirection = false
      this.filterByCallStatus = false
      this.directionOptions.map(option => (option.search = false))
      this.callStatusOptions.map(option => (option.search = false))
      this.callDuration = {
        search: false,
        value: 0
      }
      this.dateRange = {
        from: '',
        to: ''
      }
      this.filter = {
        extensions: '',
        callStatuses: '',
        directions: '',
        callDuration: '',
        dateRange: {
          from: '',
          to: ''
        }
      }
    },
    async formHandler() {
      this.formLoading = true
      const model = {
        page: this.page,
        per_page: this.per_page,
        tenant_id: this.currentAccount.id,
        schedule: {
          reportName: this.model.reportName,
          to: this.$store.getters.currentUser.email,
          cron: this.model.cron,
          cc: this.model.emails.replace(/\s/g, '').split(',')
        },
        extensions: this.filter.extensions,
        from_date: this.filter.dateRange.from,
        to_date: this.filter.dateRange.to,
        callstatus: this.filter.callStatuses,
        call_directions: this.filter.directions
      }

      if (this.filter.callDuration) {
        model.duration = this.filter.callDuration
      }

      const response = await this.scheduleReport(model)
      this.formLoading = false

      if (response.success) {
        this.$toasted.show(response.data.message, {
          icon: 'fa-check-circle',
          position: 'top-right',
          duration: 5000,
          fullWidth: false
        })
        this.$store.dispatch('togglePopup', false)
      }
    },
    async downloadReport() {
      this.downloadingFile = true
      let file = await this.exportReport({
        url: this.apiUrl,
        page: this.page,
        per_page: this.per_page
      })
      if (file) {
        this.forceFileDownload(file)
        this.downloadingFile = false
      }
    },
    forceFileDownload(response) {
      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: response.headers['content-type'] })
      )
      const link = document.createElement('a')
      link.setAttribute('download', `cdr-${Date.now()}.xls`)
      link.href = url
      document.body.appendChild(link)
      link.click()
    }
  }
}
</script>
<style lang="scss" scoped>
h4 {
  margin-top: 0;
}
.form-group {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}
</style>
<style lang="scss">
td.with-icon {
  position: relative;
}

.btn.loading {
  animation: loading 1s infinite;
}
@keyframes loading {
  0% {
    background-color: $darkblue;
  }
  25% {
    background-color: $blue;
  }
  50% {
    background-color: $darkblue;
  }
  75% {
    background-color: $blue;
  }
  100% {
    background-color: $darkblue;
  }
}
</style>
